enum NavigationMode {
	NonLinear = "nonlinear",
	InChaptersOrder = "in_chapters_order",
	InExercisesOrder = "in_exercises_order",
}

export default NavigationMode;
